import React from 'react';
import { bool } from 'prop-types';
import {
  Accordion
} from '../../genericcomponents/Accordion/Accordion';
import { CarPickerData } from '../car-picker-data/car-picker-data';
// eslint-disable-next-line max-len
import { CarPickerDropDownWithSearch } from '../car-picker-dropdown-with-search/car-picker-dropdown-with-search';
import { CarPickerTooltip } from '../car-picker-tooltip/car-picker-tooltip';

const CarPickerContent = ({
  isMobile
}) => (
  <CarPickerData>
    {(desktopArray, mobileObject, selectedOption) => {
      return !isMobile
        ? (
          <>
            {desktopArray.map(({
              optionType, optionValue, onSelect, options, classes
            }, index) => (
              <div className={classes} key={optionType}>
                {index === 0 && <CarPickerTooltip />}
                <CarPickerDropDownWithSearch
                  header={selectedOption[optionType]?.displayValue
                    || `Pick Your ${optionValue}`}
                  selectOption={`Select ${optionValue}...`}
                  options={options}
                  onSelect={onSelect}
                />
              </div>
            ))}
          </>
        )
        : (
          <>
            <CarPickerTooltip distance={62} />
            <Accordion dimensions={mobileObject} />
          </>
        );
    }}
  </CarPickerData>
);

CarPickerContent.defaultProps = {
  isMobile: false
};

CarPickerContent.propTypes = {
  isMobile: bool
};

CarPickerContent.displayName = 'CarPickerContent';

export { CarPickerContent };